module.exports = __webpack_public_path__ + "assets/img/life-9.0123c741.jpg";